import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from './slice';

const selectDomain = (state: RootState) =>
  state.dealerSegmentSettingsComponentState || initialState;

export const selectDealerSegmentSettings = createSelector(
  [selectDomain],
  state => state.dealerSegmentSettings,
);
